import type { Theme } from '@shared/protocol';

const KEY = 'nkpa-theme';

export function applyTheme(theme: Theme): void {
  document.documentElement.setAttribute('data-theme', theme);
  try {
    localStorage.setItem(KEY, theme);
  } catch {
    // Storage unavailable: the per-user preference on the server still applies after sign-in.
  }
  window.dispatchEvent(new CustomEvent('nkpa-theme', { detail: theme }));
}

export function currentTheme(): Theme {
  return document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
}
